<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"/>

      <basic-table
        @Filtred="Filtred"
        :items="customChargesReports"
        :fields="customChargesReportsFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      customChargesReports: [],
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        account_id: 0,
        limit: 500,
        download: 0
      },
      customChargesReportsFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'date', label: this.$i18n.t('Date'), sortable: true, formatter: (val, key, item) => { return this.$root.getMomentWithTZDelta(val).format('MM-DD-YYYY HH:mm:ss') }},
        {key: 'mark', label: 'Mark', sortable: true},
        {key: 'amount',
          label: this.$i18n.t('Volume'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'amount_with_tax',
          label: this.$i18n.t('Amount with TAX'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'service_name', label: this.$i18n.t('Service'), sortable: true},
        {key: 'service_key', label: this.$i18n.t('Service ID'), sortable: true},
        {key: 'revoked', label: this.$i18n.t('Revoked'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerate = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart

      if (this.userId) {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_CUSTOM_CHARGES', this.getStore).then(response => {
        if (isGenerate) {
          this.customChargesReports = this.$store.getters['Reports/CUSTOM_CHARGES']
        } else {
          download(this.$store.getters['Reports/CUSTOM_CHARGES'], 'report_services_custom_charges.csv', 'text/csv')
        }
        this.loadDone()
      })
      this.totalRows = isGenerate ? this.customChargesReports.length : 0
      this.$emit('input', this.totalRows)
      this.isGenerateDisabled = false
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_CUSTOM_CHARGES')
      this.getStore.download = 0
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  },
  watch: {
    customChargesReports: function (items) {
      for (let el of this.$store.getters['Reports/CUSTOM_CHARGES']) {
        el.service_name = decodeURI(el.service_name)
      }
      this.loadDone()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/customChargesReport/main.vue